import React from 'react';

/**
 * Catches render errors in the public route tree so one broken match record
 * shows a recoverable message instead of blanking the whole page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.handleRetry = this.handleRetry.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Render error:', error, errorInfo);
  }

  handleRetry() {
    this.setState({ hasError: false });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="empty-state" role="alert">
          <h3>This page didn't load</h3>
          <p>Something broke while rendering it. Try again, and reload the page if it keeps happening.</p>
          <button type="button" className="btn" onClick={this.handleRetry}>
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
